import { getFieldErrors, isApiError, readApiError } from '@/services/api';
import { hasJustificationRequiredCode } from './accessRefusal';

type RegistrationField = 'newVrm' | 'reason' | 'sameVehicleConfirmed';

const WIRE_TO_FORM_FIELD: Record<string, RegistrationField> = {
    new_vrm: 'newVrm',
    reason: 'reason',
    same_vehicle_confirmed: 'sameVehicleConfirmed',
};

const FALLBACK_MESSAGE = 'Failed to change the registration. Please try again.';
export const JUSTIFICATION_REQUIRED_MESSAGE =
    'Your recorded reason for accessing this Agreement has expired. Record it again, then submit this change.';

export interface RegistrationSubmitError {
    fieldErrors: { field: RegistrationField; message: string }[];
    message: string | null;
}

export function mapRegistrationSubmitError(error: unknown): RegistrationSubmitError {
    // The access gate re-opens its prompt for this refusal; this is not a permission failure.
    if (hasJustificationRequiredCode(error)) {
        return { fieldErrors: [], message: JUSTIFICATION_REQUIRED_MESSAGE };
    }

    const wireErrors = getFieldErrors(error);
    const fieldErrors = Object.entries(wireErrors).flatMap(([wireField, messages]) => {
        const field = WIRE_TO_FORM_FIELD[wireField];
        return field && messages[0] ? [{ field, message: messages[0] }] : [];
    });
    const hasUnmappedErrors = Object.keys(wireErrors).some((wireField) => !WIRE_TO_FORM_FIELD[wireField]);

    if (fieldErrors.length > 0 && !hasUnmappedErrors) {
        return { fieldErrors, message: null };
    }

    const message = isApiError(error) && error.data ? readApiError(error.data).message : FALLBACK_MESSAGE;

    return { fieldErrors, message };
}
